module.exports = __webpack_public_path__ + "img/Kay Ivey.6325ed06.jpg";